/**
 * @fileoverview UnsupportedBrowser component for rendering a message when the user is using an unsupported browser
 *
 * @example
 * // Usage in component:
 * import { UnsupportedBrowser } from './UnsupportedBrowser'
 *
 * <UnsupportedBrowser />
 */

import { Instructions } from './sections/Instructions'

import css from './InterimSuccess.module.css'
import { Title } from './sections/Title'

const INSTRUCTIONS = `The Facebook app doesn’t support this test.\n\n&nbsp;\n\nTo continue, please do the following:\n - Tap the
three dots (**···**) at the top of the page.\n - Select **Open in ...** to open Storyteller in your preferred internet browser, such as Chrome, Firefox, Edge or Safari.`

/**
 * @function UnsupportedBrowser
 * @description Component for rendering a message when the user is using an unsupported browser
 * @returns {JSX.Element} The UnsupportedBrowser component
 */
export function UnsupportedBrowser() {
    return (
        <div className={css.container}>
            <div className={css.title_container}>
                <Title>Please open Storyteller in a different internet browser</Title>
            </div>
            <Instructions instructions={INSTRUCTIONS} />
        </div>
    )
}
